type Props = {
  banner: { notice: string; v3_url: string | null } | null;
};

export function ReadOnlyBanner({ banner }: Props) {
  if (!banner) return null;
  return (
    <aside
      role="status"
      className="fixed bottom-4 left-1/2 z-[2147483647] flex max-w-[calc(100%-2rem)] -translate-x-1/2 flex-wrap items-center justify-center gap-x-4 gap-y-2 rounded-lg bg-[#172d2d] px-5 py-3 text-sm font-medium text-white shadow-lg"
    >
      {banner.notice}
      {banner.v3_url && (
        <a
          href={banner.v3_url}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#7fe0e0]"
        >
          Open V3
        </a>
      )}
    </aside>
  );
}
